var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1051_20168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.7336 5.26666C23.7103 -1.75516 12.2885 -1.75516 5.2652 5.26666C-1.75507 12.2885 -1.75507 23.7133 5.2652 30.7351C8.77685 34.2453 13.3885 35.9995 18.0002 35.9995C22.6119 35.9995 27.222 34.2452 30.7336 30.7351C37.7555 23.7133 37.7555 12.2885 30.7336 5.26666ZM25.4271 23.3066C26.0139 23.8934 26.0139 24.8418 25.4271 25.4286C25.1345 25.7212 24.7503 25.8683 24.3661 25.8683C23.982 25.8683 23.5977 25.7212 23.3051 25.4286L18.0001 20.1221L12.6966 25.427C12.4025 25.7197 12.0183 25.8668 11.6356 25.8668C11.2515 25.8668 10.8672 25.7197 10.5746 25.427C9.98785 24.8403 9.98785 23.8903 10.5746 23.3051L15.8781 18.0001L10.5731 12.6951C9.98637 12.1084 9.98637 11.1584 10.5731 10.5732C11.1584 9.98642 12.1083 9.98642 12.6951 10.5732L18.0001 15.8781L23.305 10.5732C23.8918 9.98642 24.8402 9.98642 25.427 10.5732C26.0137 11.1584 26.0137 12.1084 25.427 12.6951L20.122 18.0001L25.4271 23.3066Z",
    fill: "url(#paint0_linear_1051_20168)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1051_20168",
    x1: 18,
    y1: 0.000297546,
    x2: 18,
    y2: 35.9995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8A02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEC63"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1051_20168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.bed6615f58291ceea977e804ed57d651.svg";
export { ForwardRef as ReactComponent };